import { render } from "./GoalsAndBudget.vue?vue&type=template&id=6cde068e"
import script from "./GoalsAndBudget.vue?vue&type=script&lang=js"
export * from "./GoalsAndBudget.vue?vue&type=script&lang=js"

import "./GoalsAndBudget.vue?vue&type=style&index=0&id=6cde068e&lang=scss&scope=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__